import PropTypes from 'prop-types';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { FormattedMessage, injectIntl } from 'react-intl';

import injectTheme from '../../../common/injectTheme';
import styles from '../../../resources/static/less/comparison-components.module.less';
import { timeAgoFrom } from '../../../resources/time';

const INTERVAL = 60000;

const createClassNames = (classNames) =>
  classNames.map((className) => `${styles[className]}`).join(' ');

class MidMarketDescription extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      intervalId: null,
      formatLocale: null,
    };
  }

  componentDidMount() {
    this.setState({ intervalId: setInterval(this.timer, INTERVAL) });
  }

  componentWillUnmount() {
    const { intervalId } = this.state;
    clearInterval(intervalId);
  }

  timer() {
    this.forceUpdate();
  }

  render() {
    const { rateTime, intl, isScreenModeDark } = this.props;
    return (
      <small
        className={createClassNames([
          'small',
          'text-xs-center',
          'text-md-left',
          'rate-description',
          isScreenModeDark ? 'rate-description--dark' : '',
        ])}
      >
        <FormattedMessage id="rate-description" />
        <p className={styles['rate-description']}>
          {rateTime ? (
            <FormattedMessage
              values={{ minutes: timeAgoFrom(new Date(rateTime), intl.locale) }}
              id="rate-description-time"
            />
          ) : (
            <FormattedMessage id="rate-description-default-time" />
          )}
        </p>
      </small>
    );
  }
}

MidMarketDescription.propTypes = {
  rateTime: PropTypes.string,
};

MidMarketDescription.defaultProps = {
  rateTime: undefined,
};

export default injectTheme(injectIntl(MidMarketDescription));
